import { Component, inject, Signal } from '@angular/core';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { RouterLink } from '@angular/router';
import { SekeletonLoadingComponent } from '@therapist/shared/components/sekeleton-loading/sekeleton-loading.component';
import { NgTemplateOutlet } from '@angular/common';
import { AddTherapyPlanDataComponent } from '../../components/add-therapy-plan-data/add-therapy-plan-data.component';

@Component({
  selector: 'sana-tp-add-therapy-plan-details-page',
  imports: [
    SekeletonLoadingComponent,
    NgTemplateOutlet,
    RouterLink,
    AddTherapyPlanDataComponent
  ],
  templateUrl: './therapy-plan-add-or-edit-data-page.component.html',
  styleUrl: './therapy-plan-add-or-edit-data-page.component.scss'
})
export class TherapyPlanAddOrEditDataPageComponent {

  readonly #clientStateService = inject(TherapistClientStateService);

  isClientLoaded: Signal<boolean> = this.#clientStateService.getIsClientLoaded();
}
